<template>
 <div class="asp"> 
    <van-field
      readonly
      clickable
      label="省份"
      :value="value"
      placeholder="选择省份"		
      @click="showPicker = true"
    />
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="areaList"		  
        value-key="city"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    
    <!-- 服务网点列表 -->
    <div class="asp-list">
      <div 
        class="asp-item" 
        v-for="(item, index) in aspList" 
        :key="index"
      >
        <div class="asp-code">维修站编码: {{ item.staID || '未知' }}</div>
        <div class="asp-name">{{ item.name || '未知名称' }}</div>
        <div class="asp-info">地址: {{ item.address || '未知地址' }}</div>
        <div class="asp-info">电话: {{ item.tel || '未知电话' }}</div>
        <div class="asp-info">工作时间: {{ item.sHours || '未知工作时间' }}</div>
      </div>
    </div>
    
    <!-- 空状态 -->
    <div v-if="aspList.length === 0" class="empty-state">
      暂无服务网点数据
    </div>
 </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
export default {
  name: 'ASP',
  components: {	 
  },
  data(){
  		return{		
			value: '',
			showPicker: false,
  			areaList:[],
			aspList:[],
  		}
  	 
  },
  created(){
  	this.getData();
	this.getAsp("北京市");
  }, 
  mounted(){	
	   document.title ='服务网络';
  },
	methods:{
		getData(){		
 		var that = this
 		Vue.axios.get('https://t3.lenovoimage.com/api/login/getCity?CityID=0')
 		 .then(function (response) {
 		  that.areaList = response.data.Data;
 		 })
 		 .catch(function (error) {
 		  console.log(error);
 		 }) 		
		},	
		getAsp(province){	
			//get asp list
			var that = this
			Vue.axios.get('https://t3.lenovoimage.com/api/web2/getaspbykeyword2025?keyword=' + province)
			 .then(function (response) {
			  if (response.data && response.data.Data) {
				that.aspList = response.data.Data;			  
			  } else {
			    that.aspList = [];
			  }
			 })
			 .catch(function (error) {
			  console.log(error);
			  that.aspList = [];
			 }) 
		},
		onConfirm(value) {
			 this.value = value.city;
			 this.showPicker = false;
			 var that = this
		     that.getAsp(value.city);
		},
	}
}
</script>
<style>
  .asp {
    padding-top: 5px;
	background-color: white;
  }
  .asp-list {
    padding: 10px;
  }
  .asp-item {
    background-color: #f7f8fa;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 10px;
    border: 1px solid #ebedf0;
  }
  .asp-code {
    font-size: 12px;
    color: #969799;
    margin-bottom: 5px;
  }
  .asp-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
    color: #323233;
  }
  .asp-info {
    font-size: 14px;
    color: #646566;
    margin-bottom: 5px;
  }
  .asp-info:last-child {
    margin-bottom: 0;
  }
  .empty-state {
    text-align: center;
    padding: 40px 20px;
    color: #969799;
  }
</style>




